import {defineStore} from 'pinia';

// nvthinh 12.06.2025: Store quản lý video player thu nhỏ độc lập
export const useVideoPlayerStore = defineStore('videoPlayer', {
  state: () => ({
    isMinimized: false,
    videoLink: '',
    videoTitle: '',
    isVisible: false,
    dataParam: {},
  }),

  getters: {
    // nvthinh 12.06.2025: Kiểm tra có đang hiển thị video thu nhỏ không
    isMinimizedVisible: state => state.isMinimized && state.isVisible,
  },

  actions: {
    // nvthinh 12.06.2025: Hiển thị video thu nhỏ
    showMinimized(videoLink, videoTitle = '') {
      this.videoLink = videoLink;
      this.videoTitle = videoTitle;
      this.isMinimized = true;
      this.isVisible = true;
    },

    // nvthinh 12.06.2025: Ẩn video thu nhỏ
    hideMinimized() {
      this.isMinimized = false;
      this.isVisible = false;
      this.videoLink = '';
      this.videoTitle = '';
    },

    // nvthinh 12.06.2025: Chuyển từ thu nhỏ sang phóng to
    maximize() {
      this.isMinimized = false;
    },

    // nvthinh 12.06.2025: Chuyển từ phóng to sang thu nhỏ
    minimize() {
      this.isMinimized = true;
    },
  },
});
